import * as React from 'react';
import Component from '../../../Component';
import Manager from './Manager';
import { STATUS } from '../../../General';

export default class Attendance extends Component {
    render() {
        const caches: any = this.getCaches().getState();
        let ready = caches.leaveTypes.status === STATUS.READY &&
            caches.offices.status === STATUS.READY &&
            caches.users.status === STATUS.READY &&
            (this.getSession().getState() as any).status === STATUS.READY;
        if (ready === false) { return this.renderLoading(); }
        return (<Manager onTabChange={(value: any) => { if (this.props.onTabChange) { this.props.onTabChange(value); } }} />);
    }
}